import React from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { Button, ControlSelect, DatePicker, Form } from "../index";

export const ComplementResultsFilter = ({
  filterOptions,
  onFilterChange,
  onDateRangeChange,
}) => {
  const methods = useFormContext();
  const watchedFilterType = useWatch({
    control: methods.control,
    name: "filterType",
  });

  const watchedDateFrom = useWatch({
    control: methods.control,
    name: "dateFrom",
  });

  const watchedDateTo = useWatch({
    control: methods.control,
    name: "dateTo",
  });

  const filterSelectOptions = [
    { value: "current", label: "Aktuální výsledky" },
    { value: "last100", label: "Posledních 100 výsledků" },
    { value: "all", label: "Všechny výsledky" },
    { value: "custom", label: "Dle data" },
  ];

  // Sledovanie zmien v ControlSelect pomocou useWatch
  React.useEffect(() => {
    if (
      watchedFilterType &&
      watchedFilterType.value &&
      watchedFilterType.value !== filterOptions
    ) {
      onFilterChange(watchedFilterType.value);
    }
  }, [watchedFilterType]);

  const handleApplyDateFilter = () => {
    const fromValid =
      watchedDateFrom instanceof Date && !isNaN(watchedDateFrom);
    const toValid = watchedDateTo instanceof Date && !isNaN(watchedDateTo);
    if (!fromValid || !toValid) return;
    onDateRangeChange({
      from: watchedDateFrom.toISOString().split("T")[0],
      to: watchedDateTo.toISOString().split("T")[0],
    });
  };

  return (
    <div className="complement-results-filter">
      <Form>
        <div className="filter-row">
          <div className="filter-group">
            <ControlSelect
              name="filterType"
              label="Časové období:"
              options={filterSelectOptions}
              placeholder="Vyberte období..."
              containerClass="filter-group"
              labelClass="filter-label"
              width={300}
            />
          </div>

          {(filterOptions === "custom" ||
            watchedFilterType?.value === "custom") && (
            <div className="date-range-group">
              <DatePicker
                name="dateFrom"
                label="Datum výsledků od:"
                labelClass="filter-label"
              />
              <DatePicker
                name="dateTo"
                label="Datum výsledků do:"
                labelClass="filter-label"
              />
              {watchedDateFrom instanceof Date &&
                !isNaN(watchedDateFrom) &&
                watchedDateTo instanceof Date &&
                !isNaN(watchedDateTo) && (
                  <button
                    type="button"
                    className="button"
                    onClick={handleApplyDateFilter}
                  >
                    Filtrovat
                  </button>
                )}
            </div>
          )}
        </div>
      </Form>
    </div>
  );
};
